module.exports = __webpack_public_path__ + "static/img/logo_instagram.2fb5c869.svg";